/**
 * Rillet "Future State Systems Landscape": the same left-to-right logo diagram as Maxio, drawn
 * from the deal's own `tech_stack_systems` list (the Rillet tech-stack editor), with Rillet - the
 * new general ledger - at the centre.
 *
 *   [retired strip: every Sunset system, usually the old ERP]
 *   [CRM, billing]  <---->  [ RILLET ]  <---->  [payroll, AP automation, BI]
 *                              ^
 *                   [tax, a kept ERP, anything else]
 *
 * Cards are coloured by the user's plan (Keep green, TBD tagged). A system whose integration
 * points at another system links straight to it. Logos come from the system NAME at render time
 * (the stored answer has no logo key). Pure: the deal page and the SOW export both call it.
 */
import { buildMaxioFlowLandscape } from './maxio-flow-layout.js';
import { TECH_STACK_CATEGORIES } from './tech-stack.js';
export const RILLET_LANDSCAPE_HUB_NAME = 'Rillet';
/** True for the Rillet product key, bare or composite ('rillet' / 'rillet:rillet'). */
export function isRilletProductKey(productKey) {
    if (!productKey)
        return false;
    const k = productKey.toLowerCase();
    return k === 'rillet' || k === 'rillet:rillet';
}
export const RILLET_FLOW_OPTIONS = {
    hubName: RILLET_LANDSCAPE_HUB_NAME,
    hubLogoKey: 'rillet',
    hubInitials: 'RI',
    placement: {
        left: ['crm', 'billing-engines'],
        right: ['payroll', 'ap-automation', 'bi-analytics'],
        bottom: ['taxes', 'erp'],
    },
    categoryLabels: Object.fromEntries(TECH_STACK_CATEGORIES.map((c) => [c.id, c.label])),
    planTone: true,
};
// Checked in order against the lower-cased name with punctuation turned into spaces.
const LOGO_RULES = [
    [/\bintuit enterprise\b/, 'ies'],
    [/\bquick ?books\b/, 'qbo'],
    [/\bintacct\b/, 'sage_intacct'],
    [/\b(avalara|avatax)\b/, 'avalara'],
    [/\bauthorize net\b/, 'authorize_net'],
    [/\btax ?jar\b/, 'taxjar'],
    [/\bnet ?suite\b/, 'netsuite'],
    [/\bhub ?spot\b/, 'hubspot'],
    [/\bpay ?pal\b/, 'paypal'],
    [/\bsap\b/, 'sap'],
    [
        /\b(salesforce|pipedrive|xero|stripe|chargebee|zuora|recurly|maxio|anrok|braintree|adyen|rillet)\b/,
        '$1',
    ],
];
/** Logo key for a free-text system name ("QuickBooks Online" -> 'qbo'), or undefined. */
export function rilletLogoKeyForName(name) {
    const normalized = name
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, ' ')
        .trim();
    for (const [pattern, key] of LOGO_RULES) {
        const match = normalized.match(pattern);
        if (match)
            return key === '$1' ? match[1] : key;
    }
    return undefined;
}
/** The Rillet diagram for a deal's tech-stack systems. Empty layout when nothing is named. */
export function buildRilletLandscape(systems) {
    const withLogos = systems.map((s) => {
        const logoKey = s.logoKey ?? rilletLogoKeyForName(s.name);
        return logoKey ? { ...s, logoKey } : s;
    });
    return buildMaxioFlowLandscape(withLogos, RILLET_FLOW_OPTIONS);
}
//# sourceMappingURL=rillet-landscape.js.map